import React, { useEffect, useState } from "react";
import { BASE_URL } from "../config/api";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const EditLeave = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [staffId, setStaffId] = useState("");
  const [staffList, setStaffList] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reason, setReason] = useState("");
  const [status, setStatus] = useState("Pending");

  useEffect(() => {
    // Fetch staff list
    fetch(`${BASE_URL}staff`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 1) {
          setStaffList(data.data);
        }
      });

    // Fetch leave details
    fetch(`${BASE_URL}leaves/${id}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 1) {
          const leave = data.data;

          const formatDate = (dateStr) => {
            const date = new Date(dateStr);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
          };

          setStaffId(leave.staff_id);
          setStartDate(formatDate(leave.start_date));
          setEndDate(formatDate(leave.end_date));
          setReason(leave.reason);
          setStatus(leave.status);
        } else {
          alert("Leave not found.");
        }
      })
      .catch((error) => console.error("Error fetching leave:", error));
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const updatedLeave = {
      staff_id: parseInt(staffId),
      start_date: startDate,
      end_date: endDate,
      reason,
      status,
    };

    fetch(`${BASE_URL}leaves/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedLeave),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 1) {
          Swal.fire({
            icon: "success",
            title: "Product Edit success",
          });
          navigate("/LeaveList");
        } else {
          Swal.fire({
            icon: "error",
            title: "Error updating leave.",
          });
        }
      })
      .catch((err) => console.error("Error updating leave:", err));
  };

  return (
    <div id="main">
      <header className="mb-3">
        <a href="#" className="burger-btn d-block d-xl-none">
          <i className="bi bi-justify fs-3"></i>
        </a>
      </header>

      <div className="page-heading">
        <div className="page-title">
          <div className="row">
            <div className="col-12 col-md-6 order-md-1 order-last">
              <h3>Edit Leave</h3>
            </div>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Edit Leave Details</h4>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="staff" className="form-label">
                      Staff Name
                    </label>
                    <select
                      id="staff"
                      className="form-control"
                      value={staffId}
                      onChange={(e) => setStaffId(e.target.value)}
                      required
                    >
                      <option value="">Select Staff</option>
                      {staffList.map((staff) => (
                        <option key={staff.id} value={staff.id}>
                          {staff.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="startDate" className="form-label">
                      Start Date
                    </label>
                    <input
                      type="date"
                      id="startDate"
                      className="form-control"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="endDate" className="form-label">
                      End Date
                    </label>
                    <input
                      type="date"
                      id="endDate"
                      className="form-control"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="reason" className="form-label">
                      Reason
                    </label>
                    <textarea
                      id="reason"
                      className="form-control"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                      required
                    ></textarea>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="status" className="form-label">
                      Status
                    </label>
                    <select
                      id="status"
                      className="form-control"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                      required
                    >
                      <option value="Pending">Pending</option>
                      <option value="Approve">Approve</option>
                      <option value="Reject">Reject</option>
                    </select>
                  </div>

                  <div className="text-end">
                    <button type="submit" className="btn btn-primary">
                      Update Leave
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EditLeave;
